'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var styles = require('@material-ui/core/styles');

var useStyles = styles.makeStyles(function (theme) {
    return styles.createStyles({
        rounded: {
            color: theme.palette.primary.main,
            backgroundColor: '#E1F0FF',
            fontWeight: 500,
        },
        expandIcon: {
            color: '#aaaaaa',
        },
    });
});
var defaultButtonOverrides = {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: 'none',
    textTransform: 'none',
    marginLeft: '10px',
};
var buttonOverrides = function (style) {
    if (style === void 0) { style = {}; }
    return tslib.__assign(tslib.__assign({}, defaultButtonOverrides), style);
};

exports.buttonOverrides = buttonOverrides;
exports.useStyles = useStyles;
